import { render, staticRenderFns } from "./TeamTile.vue?vue&type=template&id=08df6196&scoped=true&"
import script from "./TeamTile.vue?vue&type=script&lang=js&"
export * from "./TeamTile.vue?vue&type=script&lang=js&"
import style0 from "./TeamTile.vue?vue&type=style&index=0&id=08df6196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08df6196",
  null
  
)

export default component.exports